import { useAi } from '@/context/ai'
import { AIElementNames, eventsTracker } from '@/lib/eventsTracker'
import { useEffect, useRef } from 'react'

function truncatePromptCleanly(prompt: string): string {
  if (prompt.length <= 125) {
    return prompt
  }
  let truncated = prompt.slice(0, 125)
  let lastSpaceIndex = truncated.lastIndexOf(' ')
  if (lastSpaceIndex > 0) {
    truncated = truncated.slice(0, lastSpaceIndex)
  }
  return truncated + '...'
}

interface Props {
  prompts: string[]
  onSubmit: (prompt: string) => void
}

const Prompts = (props: Props): JSX.Element => {
  const { state } = useAi()
  const promptRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!promptRef.current) return
    promptRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' })
  }, [state.showPrompts, promptRef.current])

  if (!state.showPrompts) return <></>
  return (
    <div ref={promptRef} className="bg-white flex flex-col w-full justify-center mt-4">
      <div className={`p-3 lg:p-[18px] xxl:p-6 rounded-2xl bg-[#E3E8F2]`}>
        <p className="text-base leading-[22px] text-primary xxl:text-xl">
          <span className="font-bold">Continue the conversation:</span> <br></br>
          <span className="italic">
            Reply to me or ask a new question in the box below, <strong>OR</strong>
            <br></br> Click a suggested follow-up question below to explore more
          </span>
        </p>
      </div>
      <h2 className="py-0 text-base xxl:mb-2 font-bold mt-6 xxl:text-xl">Curious? click one of the questions below</h2>
      {props.prompts.map((prompt, index) => (
        <button
          key={index}
          className="flex justify-between bg-white border-none w-full py-1 cursor-pointer hover:bg-[#f7f7fa]"
          onClick={() => {
            eventsTracker.handleOnClickAndTrackEvent(AIElementNames.BUTTON_DYNAMIC_PROMPTS)
            props.onSubmit(prompt)
          }}
        >
          {
            <>
              <p className={`normal-case text-left underline text-secondary xxl:text-xl`}>
                {truncatePromptCleanly(prompt)}
              </p>
              <h2 className="text-right text-lg md:text-2xl">+</h2>
            </>
          }
        </button>
      ))}
    </div>
  )
}

export default Prompts
